const sumBy = (field) => (a, e) => a + e[field];

export default sumBy;
